import { FC, ReactNode } from 'react';
import useWizardFlow from 'src/common/components/WizardFlow/useWizardFlow';

type WizardFlowPageProps = {
  children: ReactNode;
  /** Will only show if name matches active.
    * Exclude if this is the default flow */
  name?: string | number | null;
};
const WizardFlowPage: FC<WizardFlowPageProps> = ({ name = null, children }) => {
  const { active } = useWizardFlow();
  if (name !== active) {
    return null;
  }

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {children}
    </>
  );
};

export default WizardFlowPage;
